<!-- Determine component load -->
<ng-container *ngIf="url.search('login') >= 0">
    <app-login class="inherit" [bannerPromo]="bannerPromo" [logo]="logo"></app-login>
</ng-container>

<ng-container *ngIf="url.search('reset') >= 0">
    <app-resetpass [bannerPromo]="bannerPromo" [logo]="logo"></app-resetpass>
</ng-container>

<ng-container *ngIf="url.search('remember') >= 0">
    <app-rememberpass [bannerPromo]="bannerPromo" [logo]="logo"></app-rememberpass>
</ng-container>

<ng-container *ngIf="url.search('signup') >= 0">
    <app-signup-new [logo]="logo"></app-signup-new>
</ng-container>
